import { makeStyles } from '@mui/styles';

const drawerWidth = 240;

export const useStyles = makeStyles(theme => ({
    root:{
        height: '100%',
        display: 'flex',
	},
	content:{
        height: '100%',
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
        paddingTop: prop => prop?.authenticated ? 75 : 0,
        '@media (max-width:415px)':{
            marginTop: 0,
        }
	},
    icon:{
        marginRight: 5,
    },
    title_text:{
        '@media (max-width:768px)':{
            fontSize: '0.6rem'
        },
        '@media (max-width: 570px)':{
            display:'none',
        }
    },
    button: {
        '@media print':{
            display:'none',
        },
        margin: theme.spacing(1),
        '@media (max-width:768px)':{
            padding: 0
        },
        '@media (max-width: 500px)':{
            marginLeft:0,
            minWidth:10,
            padding:0,
            fontSize: '0.5rem',
        },
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        '@media (max-width:2000px)':{
          fontSize:'0.8rem',
        },
        '@media (max-width:1000px)':{
          fontSize:'1rem',
          minWidth: 200,
        },
        '@media (max-width:768px)':{
            fontSize:'0.8rem',
            minWidth: 150,
        },
        '@media (max-width:570px)':{
            fontSize:'0.5rem',
            maxWidth: 250,
        }
    },
    appIcon: {
        width: 35,
        height: 25,
        paddingRight: 10
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        background: "linear-gradient(0deg, #1d5079 20%, #205690 62%)",
        boxShadow: "none",
        height: "auto",
        '@media (max-width:500px)':{
            height: "80px"
        }
    },
    appTitle: {
        display:'flex',
        alignItems: 'center',
        color: '#fff',
        lineHeight: '27px',
        verticalAlign: 'middle',
        fontSize: '1rem',
        fontWeight: '700',
        fontFamily: 'sans-serif',
        textDecoration: 'none',
        wordWrap: 'break-word',
        width: '100%',
        '@media (max-width:992px)':{
            textAlign: 'center',
        },
        '@media (max-width:768px)':{
            fontSize:'0.8rem',
        },
        '@media (max-width:500px)':{
            fontSize:'.7rem',
        }
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        '@media (min-width: 500px)':{
            display: 'none',
        }
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        boxShadow: '30px 0px 40px 17px rgba(55,56,55,0.45)',
    },
    toolbar:{
        '@media (max-width:415px)':{
            paddingLeft: 5,
            paddingRight:5,
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
}));